import React from 'react';
import { Button } from 'antd';

interface IButton {
  label: string;
  typeButton?: string;
  handleClick?: any;
  href?: string;
  disable?: boolean;
  statusButton?: string;
}
const ButtonImport = ({
  label,
  typeButton,
  handleClick,
  href,
  disable = false
}: IButton) => {
  return (
    <div className="button-wrapper">
      <Button
        onClick={handleClick}
        className={typeButton ?? 'button-import'}
        type="primary"
        href={href}
        disabled={disable}
      >
        {label}
      </Button>
    </div>
  );
};

export default ButtonImport;
